(() => {
  if (customElements.get('orienx-gift-guide')) return;
  class OrienxGiftGuide extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.productTrack = this.querySelector('[data-mg-products]');
      this.intentTrack = this.querySelector('[data-mg-intentions]');
      this.arrows = [...this.querySelectorAll('[data-mg-step]')];
      this.dots = [...this.querySelectorAll('[data-mg-page]')];
      this.arrows.forEach(button => button.addEventListener('click', () => {
        const card = this.productTrack?.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.productTrack).gap) || 0;
        this.productTrack.scrollBy({left: Number(button.dataset.mgStep) * (card.getBoundingClientRect().width + gap), behavior: this.motion()});
      }, {signal}));
      this.dots.forEach(button => button.addEventListener('click', () => {
        const card = this.intentTrack?.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.intentTrack).gap) || 0;
        this.intentTrack.scrollTo({left: Number(button.dataset.mgPage) * this.perView() * (card.getBoundingClientRect().width + gap), behavior: this.motion()});
      }, {signal}));
      [this.productTrack, this.intentTrack].forEach(track => track?.addEventListener('scroll', () => this.schedule(), {passive:true,signal}));
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this);
      this.update();
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
    perView() { return innerWidth < 720 ? 1 : innerWidth <= 1020 ? 2 : 3; }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }
    update() {
      const track = this.productTrack;
      if (track) this.arrows.forEach(button => {
        button.disabled = Number(button.dataset.mgStep) < 0 ? track.scrollLeft <= 2 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      });
      const intents = this.intentTrack;
      if (!intents?.firstElementChild) return;
      const card = intents.firstElementChild;
      const gap = parseFloat(getComputedStyle(intents).gap) || 0;
      const pageWidth = this.perView() * (card.getBoundingClientRect().width + gap);
      const page = Math.round(intents.scrollLeft / pageWidth);
      const count = Math.ceil(intents.children.length / this.perView());
      this.dots.forEach((dot,index) => {
        dot.hidden = index >= count;
        dot.setAttribute('aria-current', String(index === page));
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('orienx-gift-guide', OrienxGiftGuide);
})();
